import { Organization } from './organization.models';

export interface OrganizationState {
  organization: Organization | null;
  isLoaded: boolean;
  isLoading: boolean;
  isUpdatingLogo: boolean;
  error: string | null;
}

type Action =
  | {
      type: 'SET_LOADING_STATE';
      payload: Pick<OrganizationState, 'isLoading' | 'isLoaded'>;
    }
  | { type: 'FETCH_ORGANIZATION' }
  | {
      type: 'FETCH_ORGANIZATION_SUCCESS';
      payload: { organization: Organization };
    }
  | { type: 'FETCH_ORGANIZATION_FAILURE'; payload: { error: string } }
  | { type: 'UPDATE_ORGANIZATION' }
  | {
      type: 'UPDATE_ORGANIZATION_SUCCESS';
      payload: { organization: Organization };
    }
  | { type: 'UPDATE_ORGANIZATION_FAILURE'; payload: { error: string } }
  | { type: 'UPDATE_ORGANIZATION_LOGO' }
  | { type: 'UPDATE_ORGANIZATION_LOGO_SUCCESS' }
  | { type: 'UPDATE_ORGANIZATION_LOGO_FAILURE'; payload: { error: string } };

export const initState: OrganizationState = {
  organization: null,
  isLoaded: false,
  isLoading: false,
  isUpdatingLogo: false,
  error: null,
};

export const organizationReducer = (
  state: OrganizationState,
  action: Action
): OrganizationState => {
  switch (action.type) {
    case 'SET_LOADING_STATE':
      return {
        ...state,
        ...action.payload,
        error: null,
      };

    case 'FETCH_ORGANIZATION':
    case 'UPDATE_ORGANIZATION':
      return {
        ...state,
        isLoading: true,
        isLoaded: !!state.organization,
        error: null,
      };
    case 'FETCH_ORGANIZATION_SUCCESS':
    case 'UPDATE_ORGANIZATION_SUCCESS':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        organization: action.payload.organization,
      };
    case 'UPDATE_ORGANIZATION_LOGO':
    case 'UPDATE_ORGANIZATION_LOGO_SUCCESS':
      return {
        ...state,
        isUpdatingLogo: action.type === 'UPDATE_ORGANIZATION_LOGO',
      };
    case 'FETCH_ORGANIZATION_FAILURE':
    case 'UPDATE_ORGANIZATION_FAILURE':
    case 'UPDATE_ORGANIZATION_LOGO_FAILURE':
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        error: action.payload.error,
      };

    default:
      return state;
  }
};
